import { formatUnits } from '@shared/lib/format';
import type { NavHistoryItem, VaultActivityItem, VaultTrade } from './token-vault-position.schema';

const USDC_DECIMALS = 6;
/** NAV the token vault was launched at (USDC per coin). */
const LAUNCH_NAV = 0.1;

export function navPoints(history: NavHistoryItem[]): number[] {
  return history.map(h => parseFloat(h.nav));
}

export function navPerfPct(history: NavHistoryItem[]): number {
  const first = history[0];
  const last = history.at(-1);
  if (!first || !last) return 0;
  const firstNav = parseFloat(first.nav);
  const lastNav = parseFloat(last.nav);
  return firstNav ? ((lastNav - firstNav) / firstNav) * 100 : 0;
}

export function navSinceLaunchPct(nav: number): number {
  return (nav / LAUNCH_NAV - 1) * 100;
}

export function rawToUsd(raw: bigint | undefined): number {
  return raw === undefined ? 0 : Number(formatUnits(raw, USDC_DECIMALS));
}

export interface VaultTradeRow {
  id: string;
  question: string;
  side: 'BUY' | 'SELL';
  priceCents: string;
  shares: string;
  volumeUsd: string;
  createdAt: string;
}

export function tradeToRow(t: VaultTrade): VaultTradeRow {
  return {
    id: t.id,
    question: t.marketQuestion,
    side: t.side,
    priceCents: (parseFloat(t.avgPriceUsdc) * 100).toFixed(0),
    shares: parseFloat(t.sharesAmount).toLocaleString('en-US', { maximumFractionDigits: 2 }),
    volumeUsd: '$' + t.totalUsdcRaw,
    createdAt: t.createdAt,
  };
}

export interface VaultActivityRow {
  id: string;
  type: 'deposit' | 'withdraw';
  amountUsd: string;
  status: string;
  createdAt: string;
}

export function activityToRow(a: VaultActivityItem): VaultActivityRow {
  const usd = Number(formatUnits(a.amountRaw, USDC_DECIMALS));
  const sign = a.type === 'deposit' ? '+' : '−';
  return {
    id: a.intentId,
    type: a.type,
    amountUsd: `${sign}$${usd.toLocaleString('en-US', { maximumFractionDigits: 2 })}`,
    status: a.status,
    createdAt: a.createdAt,
  };
}
